const CLIENT_ID_KEY = 'client_id'
const RETURN_URL_KEY = 'redirect_uri'

export const login = ({ loginLocation, clientId, returnURL }) => {
  const queryParams = {
    [CLIENT_ID_KEY]: clientId,
    [RETURN_URL_KEY]: returnURL
  }

  const searchParams = new URLSearchParams(queryParams)
  const querystring = searchParams.toString()

  window.location.href = `${loginLocation}?${querystring}/`
}
